import { parseException } from "../errors";
export class ContactsController {
    constructor(axios) {
        this.axios = axios;
    }
    async getStatistics(dto) {
        try {
            const response = await this.axios.post("/contacts/statistics", dto);
            return response.data;
        }
        catch (e) {
            throw parseException(e);
        }
    }
    async find(filter) {
        try {
            const response = await this.axios.get("/contacts", {
                params: filter,
            });
            return response.data;
        }
        catch (e) {
            throw parseException(e);
        }
    }
    async detail(id) {
        try {
            const response = await this.axios.get(`/contacts/${id}`);
            return response.data;
        }
        catch (e) {
            throw parseException(e);
        }
    }
    async count(filter) {
        try {
            const response = await this.axios.get("/contacts/count", {
                params: filter,
            });
            return response.data;
        }
        catch (e) {
            throw parseException(e);
        }
    }
    async create(data) {
        try {
            const response = await this.axios.post("/contacts", data);
            return response.data;
        }
        catch (e) {
            throw parseException(e);
        }
    }
    async update(id, data) {
        try {
            const response = await this.axios.put(`/contacts/${id}`, data);
            return response.data;
        }
        catch (e) {
            throw parseException(e);
        }
    }
    async delete(id) {
        try {
            const response = await this.axios.delete(`/contacts/${id}`);
            return response.data;
        }
        catch (e) {
            throw parseException(e);
        }
    }
    async getAllTags() {
        try {
            const response = await this.axios.get(`/contacts/tags`);
            return response.data;
        }
        catch (e) {
            throw parseException(e);
        }
    }
}
